/**
 * SuggestionChips — context-aware suggestion chips.
 * Shows different chips based on: empty state, partial input, post-response.
 */
import { cn } from "@/lib/utils";

interface SuggestionChipsProps {
  chips: string[];
  onSelect: (chip: string) => void;
  isLoading?: boolean;
  className?: string;
}

export const SuggestionChips = ({
  chips,
  onSelect,
  isLoading = false,
  className,
}: SuggestionChipsProps) => {
  if (chips.length === 0) return null;

  return (
    <div className={cn("flex flex-wrap gap-1.5 px-4 py-2", className)}>
      {chips.map((chip) => (
        <button
          key={chip}
          onClick={() => onSelect(chip)}
          disabled={isLoading}
          className={cn(
            "text-[11px] px-2.5 py-1 rounded-full font-medium",
            "bg-white border border-gray6 text-gray2",
            "hover:border-greentab hover:bg-green4 hover:text-green2",
            "transition-all duration-150 cursor-pointer",
            "disabled:opacity-50 disabled:cursor-not-allowed"
          )}
        >
          {chip}
        </button>
      ))}
    </div>
  );
};
